import React, { FunctionComponent, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../../../redux/app/hooks";
import { login, setLoginPage, setLoginUser, setTeacherMainRoute, setSchoolType, logout } from "../../../redux/slices/authSlice";
import { CheckCircle } from "@mui/icons-material";
import { useMutation } from "@apollo/client";
import { RESUME_PAYMENT } from "../api/AdminLoginQuery";
import ToasterWithMessage from "../../../components/toaster";
import "./PaymentStatus.scss";

const PaymentSuccess: FunctionComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [isPaymentConfirmed, setIsPaymentConfirmed] = useState<boolean>(false);
  const { success, error } = ToasterWithMessage();

  const [resumeVirtualSchoolPayment, { loading: isConfirming }] = useMutation(RESUME_PAYMENT, {
    fetchPolicy: "no-cache",
  });

  const handleContinue = () => {
    const queryParams = new URLSearchParams(location.search);
    const from = queryParams.get("from");
    const accessToken = localStorage.getItem(Object.keys(localStorage).find((key) => key.includes("accessToken")) as string) || "";

    // If payment was triggered from the login flow (scenario B)
    if (from === "login" || accessToken) {
      localStorage.removeItem("registered_username");
      dispatch(setLoginPage({ loginPage: "student" }));
      dispatch(login({ role: "student" }));
      dispatch(setLoginUser({ loginAs: "student" }));
      dispatch(setTeacherMainRoute({ teacherMainRoute: "/student-verifyCode" }));
      dispatch(setSchoolType({schoolType: 'VIRTUAL'}));
      navigate("/student-verifyCode");
    } else {
      // If payment was triggered from registration flow (scenario A)
      navigate("/virtual-school/virtual-login", { state: { prefillUsername: true } });
    }
  };

  const handleConfirmPayment = async () => {
    try {
      const result = await resumeVirtualSchoolPayment({
        variables: {
          isPaidCheck: true
        }
      });
      const paymentData = result?.data?.resumeVirtualSchoolPayment;
      if (paymentData) {
        if (!paymentData.hasRegistration) {
          error("No active registration found. Please sign up to proceed.");
          setTimeout(() => {
            dispatch(logout());
            navigate('/');
          }, 2000);
          return;
        }

        if (paymentData.pendingStatus) {
          // If pendingStatus is true, stay here and explore remains disabled
          error("Payment is pending. Please try again.");
          setIsPaymentConfirmed(false);
        } else {
          setIsPaymentConfirmed(true);
        }
      }
    } catch (err: any) {
      console.error("Error confirming payment:", err);
      error(err?.message || "Failed to confirm payment status.");
      setIsPaymentConfirmed(false);
    }
  };

  return (
    <div className="paymentStatusCtn">
      <div className="paymentCard">
        <div className="successIconOuter">
          <div className="successIconInner">
            <CheckCircle />
          </div>
        </div>
        <h2 className="statusTitle">
          {/* {isPaymentConfirmed ? "Payment Successful" : "Confirm Payment"} */}
          Payment Successful
        </h2>
        <p className="statusDescription">
          {isPaymentConfirmed
            ? "Your payment is verified. Click Explore to continue."
            : "Please confirm your payment to activate your classroom access."}
        </p>
        <div className="actionBtnRow">
          <button 
            onClick={handleConfirmPayment} 
            className="btnConfirm" 
            disabled={isPaymentConfirmed || isConfirming}
          >
            {isConfirming ? "Confirming..." : "Confirm Payment"}
          </button>
          <button 
            onClick={handleContinue} 
            className="btnExplore" 
            disabled={!isPaymentConfirmed}
          >
            Explore
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
